import { motion } from "framer-motion";

export default function AnimatedLetters({ text, className, delay = 0 }) {
    const letters = text.split("");

    const container = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.05,
                delayChildren: delay
            }
        }
    };

    const child = {
        hidden: { y: 5, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    };

    return (
        <motion.span
            className={className}
            variants={container}
            initial="hidden"
            animate="visible"
            style={{ display: "inline-block" }}
        >
            {letters.map((char, i) => (
                <motion.span
                    key={i}
                    variants={child}
                    style={{ display: "inline-block", whiteSpace: "pre", willChange: 'transform' }}
                >
                    {char}
                </motion.span>
            ))}
        </motion.span>
    );
}
